var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tooltip',{attrs:{"left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({attrs:{"small":"","color":_vm.pushOrderExpiredAlertColor}},'v-icon',attrs,false),on),[_vm._v(" "+_vm._s(_vm.getIcon)+" ")])]}}])},[(!_vm.pushOrderExpirationDate)?_c('span',[_vm._v("Necessita de PO")]):_c('span',[_vm._v(_vm._s(_vm.getLegend))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }